import Icon from '../../../components/AppIcon';
import { CommunicationFeature } from '../types';

const FeaturesGrid = () => {
  const features: CommunicationFeature[] = [
    {
      id: "1",
      icon: "MessageSquare",
      title: "WhatsApp Business API",
      description: "Official WhatsApp Business API integration for professional, scalable messaging",
      benefits: [
        "Automated customer support responses",
        "Order confirmations and updates",
        "Appointment reminders and scheduling",
        "Lead qualification workflows"
      ]
    },
    {
      id: "2",
      icon: "Mail",
      title: "Email Sequence Automation",
      description: "Intelligent email campaigns that nurture leads and drive conversions",
      benefits: [
        "Personalized drip campaigns",
        "Behavioral trigger emails",
        "A/B testing automation",
        "Performance analytics tracking"
      ]
    },
    {
      id: "3",
      icon: "Users",
      title: "Multi-Channel Coordination",
      description: "Seamlessly coordinate WhatsApp and email for unified customer journeys",
      benefits: [
        "Cross-channel message synchronization",
        "Unified customer conversation history",
        "Smart channel preference detection",
        "Consistent brand messaging"
      ]
    },
    {
      id: "4",
      icon: "Zap",
      title: "Instant Response System",
      description: "AI-powered instant responses that feel human and convert leads",
      benefits: [
        "Natural language understanding",
        "Context-aware responses",
        "Sentiment analysis integration",
        "Escalation to human agents"
      ]
    },
    {
      id: "5",
      icon: "BarChart3",
      title: "Analytics & Insights",
      description: "Comprehensive communication analytics to optimize your automation",
      benefits: [
        "Message delivery and open rates",
        "Response time tracking",
        "Conversion funnel analysis",
        "ROI measurement dashboard"
      ]
    },
    {
      id: "6",
      icon: "Shield",
      title: "Compliance & Security",
      description: "Enterprise-grade security with full GDPR and data protection compliance",
      benefits: [
        "End-to-end encryption",
        "GDPR compliance tools",
        "Data retention policies",
        "Audit trail logging"
      ]
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary mb-4">
            Powerful Communication Features
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Everything you need to automate, optimize, and scale your customer communications
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-shadow duration-fast"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-lg">
                  <Icon name={feature.icon} size={24} className="text-primary" />
                </div>
                <h3 className="text-xl font-semibold text-text-primary">{feature.title}</h3>
              </div>

              <p className="text-text-secondary mb-4">{feature.description}</p>

              <ul className="space-y-2">
                {feature.benefits.map((benefit, index) => (
                  <li key={index} className="flex items-start gap-2">
                    <Icon name="Check" size={16} className="text-success mt-1 flex-shrink-0" />
                    <span className="text-sm text-text-secondary">{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesGrid;